'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
var ButtonPlain = require('../ButtonPlain/ButtonPlain.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-error-notice',
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function ErrorNotice(_ref) {
  var buttonIcon = _ref.buttonIcon,
      buttonLabel = _ref.buttonLabel,
      className = _ref.className,
      content = _ref.content,
      iconId = _ref.iconId,
      link = _ref.link,
      onClick = _ref.onClick,
      title = _ref.title;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnIcon
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: iconId,
    size: "md"
  })), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("h3", null, title), content && /*#__PURE__*/React__default.createElement("p", null, content), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: buttonLabel,
    iconId: buttonIcon,
    link: link,
    onClick: onClick
  }));
}
ErrorNotice.propTypes = {
  /** */
  buttonIcon: PropTypes.string,

  /** */
  buttonLabel: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** */
  content: PropTypes.string,

  /** */
  iconId: PropTypes.string,

  /** */
  link: PropTypes.string,

  /** */
  onClick: PropTypes.func,

  /** */
  title: PropTypes.string.isRequired
};
ErrorNotice.defaultProps = {
  iconId: 'info',
  onClick: function onClick() {
    return void 0;
  }
};

module.exports = ErrorNotice;
